import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { sendGetRequestApi } from "../../../services/service";

const initialState = {
  data: {},
  status: "idle",
  loading: false,
  error: "",
};

// Define the async thunk for applying for a job
export const getMcq = createAsyncThunk("getMcqs", async ({currentPage,difficulty,questionstatus,searchedWord}) => {
  try {
    const response = await  sendGetRequestApi("/mcq",{limit:10,skip:currentPage,difficultyLevel:difficulty === "all" ? "" : difficulty,status:questionstatus === "all" ? "" : questionstatus ,search:searchedWord});
    return response;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
});

export const getCoding = createAsyncThunk("getCoding", async ({currentPage,difficulty,questionstatus,searchedWord}) => {
  try {
    const response = await  sendGetRequestApi("/coding",{limit:10,skip:currentPage,difficultyLevel:difficulty === "all" ? "" : difficulty,status:questionstatus === "all" ? "" : questionstatus ,search:searchedWord});
    return response;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
});



export const getBehavioural = createAsyncThunk("getBehavioural", async ({currentPage,difficulty,questionstatus,searchedWord}) => {
  try {
    const response = await  sendGetRequestApi("/behavior",{limit:10,skip:currentPage,difficultyLevel:difficulty === "all" ? "" : difficulty,status:questionstatus === "all" ? "" : questionstatus ,search:searchedWord});
    return response;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
});

const getApiSlice = createSlice({
  name: "getApi",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getMcq.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getMcq.fulfilled, (state, action) => {
        state.status = "idle";
        state.data.mcqData = action.payload;
      })

      .addCase(getMcq.rejected, (state, action) => {
        state.status = "idle";
        state.data.mcqData = {
          status: "failed ",
          message: `${action.error.name} : ${action.error.message}`,
        };
      })


      .addCase(getCoding.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getCoding.fulfilled, (state, action) => {
        state.status = "idle";
        state.data.codingData = action.payload;
      })

      .addCase(getCoding.rejected, (state, action) => {
        state.status = "idle";
        state.data.codingData = {
          status: "failed ",
          message: `${action.error.name} : ${action.error.message}`,
        };
      })

      .addCase(getBehavioural.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getBehavioural.fulfilled, (state, action) => {
        state.status = "idle";
        state.data.behaviouralData = action.payload;
      })

      .addCase(getBehavioural.rejected, (state, action) => {
        state.status = "idle";
        state.data.behaviouralData = {
          status: "failed ",
          message: `${action.error.name} : ${action.error.message}`,
        };
      })
  },
});

export default getApiSlice.reducer;
